var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:_vm.value && _vm.value.comment === '+1'
      ? 'success'
      : _vm.value.comment === '-1'
      ? 'error'
      : ''},[(!_vm.disabled)?_c('v-btn',{attrs:{"text":"","block":""},on:{"click":_vm.update}},[_vm._v(" "+_vm._s(_vm.value.comment || "–")+" ")]):_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.value.comment || "–"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }